package com.ballisticapps.DreamJournalAIWebsite.util

object Constants {
    const val SECTION_WIDTH = 1920
    const val FONT_FAMILY = "Roboto"
}